import AdminLayout from "./AdminLayout.vue"
import WebLayout from "./WebLayout.vue"

const components = [
    AdminLayout,
    WebLayout
];
components.forEach(component => {
    window[component.name] = component;
});
const install = function (Vue) {
    components.forEach(component => {
        window[component.name] = component;
        Vue.component(component.name, component);
    });
}

export default {
    version: '3.0.0',
    install,
}